import { ListOption } from '../organisms/list/list-option/list-option.type'

export const findIndexOfOption = (options: ListOption[], optionValue: ListOption['value']) => {
  const matchingIndex = options.findIndex((option) => option.value === optionValue)

  return matchingIndex >= 0 ? matchingIndex : 0
}
